import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, switchMap, throwError } from 'rxjs';

@Injectable()
export class DataInterceptor implements HttpInterceptor {
  constructor() {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      switchMap(event => {
        if (event instanceof HttpResponse && event.body) {
          if (event.body.success) {
            return of(
              event.clone({
                body: event.body.data
              })
            );
          } else if (request.params.get('staticFile')) {
            return of(event);
          } else {
            return throwError(() => event.body);
          }
        }

        return of(event);
      })
    );
  }
}
